import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Header } from '../../components/Header/Header'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import gridClasses from '../../styles/grid.module.css'
import { ReactComponent as PlayIcon } from '../../assets/icons/about-us-video-icon.svg'
import { ReactComponent as LeftIcon } from '../../assets/icons/arrow-left.svg'
import { ReactComponent as RightIcon } from '../../assets/icons/arrow-right.svg'
import { ReactComponent as ClassIcon } from '../../assets/icons/Class.svg'
import { ReactComponent as CourseIcon } from '../../assets/icons/Courses.svg'
import { ReactComponent as UsersIcon } from '../../assets/icons/Users.svg'
import { VideoPlayer } from '../../components/VideoPlayer/VideoPlayer'
import Carousel from '../../components/Carousel/Carousel'
import classes from './AboutUs.module.css'
import { Button, ButtonIcon } from '../../components/Button/Button'
import Footer from '../../components/Footer/Footer'
import learningBg from '../../assets/images/leopard-thing.jpg'
import { dashboardSelectors } from '../Homepage/dashboardSlice'
import { aboutUsSelectors } from './aboutUsSlice'
import { getOurReachStats } from './aboutUsApi'
import notification from '../../components/Notification/notification'
import Spinner from '../../components/loaders/Spinner'
import AboutUsImage from '../../assets/images/about-us.jpg'
import OurValueImage from '../../assets/images/our-values.jpg'
import StartLearningImage from '../../assets/images/start-learning.jpg'

const ValueSection = () => {
    return (
        <div
            className={classes.valueSection}
            style={{ backgroundImage: `url(${OurValueImage})` }}
        >
            <div
                className={classNames(
                    gridClasses.container,
                    gridClasses.containerTransparent
                )}
            >
                <div className={classes.infoSection}>
                    <h1 className={classes.infoSectionTitle}>Our Values</h1>
                    <div className={classes.pointList}>
                        <div
                            className={classes.pointListItem}
                            style={{
                                '--color': '#F87488',
                                '--shadow': 'rgba(248,116,136,0.25)',
                            }}
                        >
                            <div className={classes.pointIconWrapper}>
                                {/* TODO: Add icon */}
                            </div>
                            <h5 className={classes.pointTitle}>Integrity</h5>
                            <div className={classes.pointDivider} />
                            <p className={classes.pointText}>
                                Every one of our courses is designed with the
                                utmost integrity towards ourselves, as well as
                                our customers. We know you want the right
                                information, and we vow to stay true to
                                providing exactly that.
                            </p>
                        </div>
                        <div
                            className={classes.pointListItem}
                            style={{
                                '--color': '#6DC9C8',
                                '--shadow': 'rgba(109,201,200,0.5)',
                            }}
                        >
                            <div className={classes.pointIconWrapper}>
                                {/* TODO: Add icon */}
                            </div>
                            <h5 className={classes.pointTitle}>
                                Sustainability
                            </h5>
                            <div className={classes.pointDivider} />
                            <p className={classes.pointText}>
                                Our courses are not just suitable for the now,
                                but also implementable for the future. You can
                                trust that the solutions contained in our
                                courses can be maintained at a certain level or
                                rate easily, for future endeavours in your
                                business.
                            </p>
                        </div>
                        <div
                            className={classes.pointListItem}
                            style={{
                                '--color': '#B887F8',
                                '--shadow': 'rgba(184,135,248,0.3)',
                            }}
                        >
                            <div className={classes.pointIconWrapper}>
                                {/* TODO: Add icon */}
                            </div>
                            <h5 className={classes.pointTitle}>Innovation</h5>
                            <div className={classes.pointDivider} />
                            <p className={classes.pointText}>
                                It is all about staying relevant. To keep our
                                customers growing, we constantly look for how to
                                capture our value in a new way for better
                                efficiency, so we can serve you better.
                            </p>
                        </div>
                        <div
                            className={classes.pointListItem}
                            style={{
                                '--color': '#FF9655',
                                '--shadow': 'rgba(255,150,85,0.3)',
                            }}
                        >
                            <div className={classes.pointIconWrapper}>
                                {/* TODO: Add icon */}
                            </div>
                            <h5 className={classes.pointTitle}>Completeness</h5>
                            <div className={classes.pointDivider} />
                            <p className={classes.pointText}>
                                We've imbibed a culture of attention-to-detail
                                in our courses, that make them rich and
                                wholesome. This way, you are guaranteed holistic
                                one-stop-shop solutions as you learn your way to
                                growth.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const AboutUs = () => {
    const prevButtons = useRef([])
    const nextButtons = useRef([])
    const dispatch = useDispatch()
    const ourReachStats = useSelector(aboutUsSelectors.ourReachStats)
    const isFetchingOurReachStats = useSelector(aboutUsSelectors.isFetching)
        .ourReachStats
    const ourReachStatsErrorMessage = useSelector(aboutUsSelectors.errorMessage)
        .ourReachStats
    const ourReachStatsHasError = useSelector(aboutUsSelectors.hasError)
        .ourReachStats

    useEffect(() => {
        dispatch(getOurReachStats())
    }, [])

    useEffect(() => {
        if (ourReachStatsHasError) {
            notification.failure({
                title: 'Failed to load reach data',
                description: ourReachStatsErrorMessage,
            })
        }
    }, [ourReachStatsHasError])

    const formatShortForm = (num, digits) => {
        const si = [
            { value: 1, symbol: '' },
            { value: 1e3, symbol: 'k' },
            { value: 1e6, symbol: 'M' },
            { value: 1e9, symbol: 'B' },
            { value: 1e12, symbol: 'T' },
            { value: 1e15, symbol: 'Qd' },
            { value: 1e18, symbol: 'Qt' },
        ]
        // used to remove trailing zeroes
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
        let i
        for (i = si.length - 1; i > 0; i -= 1) {
            if (num >= si[i].value) {
                break
            }
        }
        return (
            (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
        )
    }

    const reachDetails = useMemo(
        () => [
            {
                style: {
                    backgroundColor: '#6DC9C8',
                    boxShadow: '0 8px 15px 0 rgba(109,201,200,0.5)',
                },
                number: formatShortForm(ourReachStats?.courses || 0),
                category: 'Courses',
                icon: CourseIcon,
            },
            {
                style: {
                    backgroundColor: '#B887F8',
                    boxShadow: '0 8px 15px 0 rgba(184,135,248,0.5)',
                },
                number: formatShortForm(ourReachStats?.courseEnrolled || 0),
                category: 'Course Enrollments',
                icon: CourseIcon,
            },
            {
                style: {
                    backgroundColor: '#EB6324',
                    boxShadow: '0 8px 15px 0 rgba(255,228,207,0.5)',
                },
                number: formatShortForm(ourReachStats?.classes || 0),
                category: 'Physical Classes',
                icon: ClassIcon,
            },
            {
                style: {
                    backgroundColor: '#F87488',
                    boxShadow: '0 8px 15px 0 rgba(248,116,136,0.5)',
                },
                number: formatShortForm(ourReachStats?.students || 0),
                category: 'Students',
                icon: UsersIcon,
            },
        ],
        [ourReachStats]
    )

    return (
        <>
            <div
                className={classes.header}
                style={{ backgroundImage: `url(${AboutUsImage})` }}
            >
                <Header />
                <div
                    className={classNames(
                        classes.storyGrid,
                        gridClasses.container
                    )}
                >
                    <div>
                        <h3 className={classes.storyHeader}>About us</h3>
                        <span className={classes.storySplitLine} />
                        <div className={classes.storyPlayLink}>
                            {/* <PlayIcon /> */}
                            <span className={classes.storyPlayLinkText}>
                                Upturn was founded with a vision to create a
                                hands-on, step-by-step, micro-sized learning
                                platform for businesses to implement better
                                processes.
                            </span>
                            {/* <RightIcon /> */}
                        </div>
                    </div>
                    <iframe
                        className={classes.storyVideo}
                        width="100%"
                        height="400"
                        src="https://www.youtube.com/embed/n1dqwRyqaXs"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                    {/* <VideoPlayer
                        poster={'https://picsum.photos/500'}
                        sources={[
                            {
                                src:
                                    'https://archive.org/download/ace_200911_04/00130d67f8ea0c43de91d30cdc13386c.mts-mp430-272.mp4',
                            },
                        ]}
                        className={classes.storyVideo}
                    /> */}
                </div>
            </div>
            <main className={gridClasses.container}>
                <section className={classes.section}>
                    <h3
                        className={`${classes.sectionHeader} ${classes.ourImpactHeader}`}
                    >
                        Implemented Learning
                    </h3>
                    <div className={classes.ourImpactRow}>
                        <span className={classes.ourImpactText}>
                            A glimpse of some of our step-by-step lessons with a
                            focus on implementation.
                        </span>
                        {/* <div className={classes.ourImpactButtons}>
                            <button
                                className={classes.ourImpactButton}
                                ref={button => prevButtons.current.push(button)}
                            >
                                <LeftIcon
                                    className={classes.ourImpactButtonIcon}
                                />
                            </button>
                            <button
                                className={classes.ourImpactButton}
                                ref={button => nextButtons.current.push(button)}
                            >
                                <RightIcon
                                    className={classes.ourImpactButtonIcon}
                                />
                            </button>
                        </div> */}
                    </div>
                    <div className={classes.carouselWrapper}>
                        <button
                            ref={button => prevButtons.current.push(button)}
                            className={classNames(
                                classes.carouselMobileButton,
                                classes.carouselMobileButtonLeft
                            )}
                        >
                            <LeftIcon
                                className={classes.carouselMobileButtonIcon}
                            />
                        </button>
                        <button
                            className={classNames(
                                classes.carouselMobileButton,
                                classes.carouselMobileButtonRight
                            )}
                            ref={button => nextButtons.current.push(button)}
                        >
                            <RightIcon
                                className={classes.carouselMobileButtonIcon}
                            />
                        </button>
                        <Carousel
                            prevButton={prevButtons}
                            nextButton={nextButtons}
                            slideClassName={classes.impactSlideWrapper}
                        >
                            <div className={classes.impactSlide}>
                                {/* <VideoPlayer
                                    poster={'https://picsum.photos/500'}
                                    sources={[
                                        {
                                            src:
                                                'https://archive.org/download/ace_200911_04/00130d67f8ea0c43de91d30cdc13386c.mts-mp430-272.mp4',
                                        },
                                    ]}
                                    className={classes.impactSlideVideo}
                                /> */}
                                <iframe
                                    className={classes.impactSlideVideo}
                                    width="100%"
                                    height="315"
                                    src="https://www.youtube.com/embed/pAOaZPor2aQ"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                ></iframe>
                                <span className={classes.impactSlideText}>
                                    Goal glimpse
                                </span>
                            </div>
                            <div className={classes.impactSlide}>
                                {/* <VideoPlayer
                                    poster={'https://picsum.photos/500'}
                                    sources={[
                                        {
                                            src:
                                                'https://archive.org/download/ace_200911_04/00130d67f8ea0c43de91d30cdc13386c.mts-mp430-272.mp4',
                                        },
                                    ]}
                                    className={classes.impactSlideVideo}
                                /> */}
                                <iframe
                                    className={classes.impactSlideVideo}
                                    width="100%"
                                    height="315"
                                    src="https://www.youtube.com/embed/PYzFJjYavW0"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                ></iframe>
                                <span className={classes.impactSlideText}>
                                    Vision glimpse
                                </span>
                            </div>
                            <div className={classes.impactSlide}>
                                {/* <VideoPlayer
                                    poster={'https://picsum.photos/500'}
                                    sources={[
                                        {
                                            src:
                                                'https://archive.org/download/ace_200911_04/00130d67f8ea0c43de91d30cdc13386c.mts-mp430-272.mp4',
                                        },
                                    ]}
                                    className={classes.impactSlideVideo}
                                /> */}
                                <iframe
                                    className={classes.impactSlideVideo}
                                    width="100%"
                                    height="315"
                                    src="https://www.youtube.com/embed/5dvJJWH5yEg"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                ></iframe>
                                <span className={classes.impactSlideText}>
                                    Recruitment overview glimpse
                                </span>
                            </div>
                            {/* <div className={classes.impactSlide}>
                                <VideoPlayer
                                    poster={'https://picsum.photos/500'}
                                    sources={[
                                        {
                                            src:
                                                'https://archive.org/download/ace_200911_04/00130d67f8ea0c43de91d30cdc13386c.mts-mp430-272.mp4',
                                        },
                                    ]}
                                    className={classes.impactSlideVideo}
                                />
                                <span className={classes.impactSlideText}>
                                    SME Upturn is your one stop shop to help you
                                    grow your business.
                                </span>
                            </div> */}
                        </Carousel>
                    </div>
                </section>
                <ValueSection />
                <section
                    className={classNames(classes.section, classes.ourReach)}
                >
                    <div className={classes.ourReachText}>
                        <span className={classes.ourReachLine} />
                        <h3 className={classes.ourReachHeader}>Our Reach</h3>
                        <p className={classes.ourReachSubtext}>
                            A look at our journey so far.
                        </p>
                    </div>
                    <div className={classes.ourReachNumbers}>
                        {isFetchingOurReachStats ? (
                            <Spinner />
                        ) : (
                            reachDetails.map(
                                ({ style, icon: Icon, number, category }) => (
                                    <div className={classes.ourReachNumber}>
                                        <div
                                            className={
                                                classes.ourReachNumberIconWrapper
                                            }
                                            style={style}
                                        >
                                            <Icon
                                                className={
                                                    classes.ourReachNumberIcon
                                                }
                                            />
                                        </div>
                                        <span
                                            className={
                                                classes.ourReachNumberValue
                                            }
                                        >
                                            {number}
                                        </span>
                                        <span
                                            className={
                                                classes.ourReachNumberCategory
                                            }
                                        >
                                            {category}
                                        </span>
                                    </div>
                                )
                            )
                        )}
                    </div>
                </section>
                <section className={classes.section}>
                    <div className={classes.startLearningImageWrapper}>
                        <img
                            src={StartLearningImage}
                            alt="Start Learning"
                            className={classes.startLearningImage}
                        />
                        <div className={classes.startLearningMobileText}>
                            <h2
                                className={
                                    classes.startLearningMobileTextHeader
                                }
                            >
                                Start Learning
                            </h2>
                            <h4
                                className={
                                    classes.startLearningMobileTextSubtext
                                }
                            >
                                We guarantee a hands-on approach to our lessons,
                                with practical knowledge on HOW to do, and not
                                just what to do. Take a course today
                            </h4>
                            <Button
                                className={classes.startLearningLink}
                                to={'/app/auth/sign-up'}
                            >
                                Start Growing
                                <ButtonIcon icon={<RightIcon />} />
                            </Button>
                        </div>
                    </div>
                    <div className={classes.startLearning}>
                        {/*<img src={learningBg} alt="Background" className={classes.startLearningBackground}/>*/}
                        <h2 className={classes.startLearningHeader}>
                            Start Learning
                        </h2>
                        <h4 className={classes.startLearningText}>
                            We guarantee a hands-on approach to our lessons,
                            with practical knowledge on HOW to do, and not just
                            what to do. Take a course today
                        </h4>
                        <Button
                            uppercase
                            className={classes.startLearningLink}
                            to={'/app/auth/sign-up'}
                        >
                            Get Started
                            <ButtonIcon icon={<RightIcon />} />
                        </Button>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}

export default AboutUs
